import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, Lock, ArrowRight } from 'lucide-react';
import { loginApi } from '../api/auth';
import Toast from '../components/Toast/Toast';
import '../styles/auth.scss';

function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ account: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ visible: false, message: '' });

  const onChange = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
    setErrors(prev => ({ ...prev, [key]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.account.trim()) errs.account = '请输入账号';
    if (!form.password) errs.password = '请输入密码';
    else if (form.password.length < 6) errs.password = '密码至少6位';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await loginApi(form);
      // 存储 token 和用户信息
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo));
      navigate('/');
    } catch (err) {
      setToast({ visible: true, message: err.message || '登录失败' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Toast visible={toast.visible} message={toast.message} onClose={() => setToast({ visible: false, message: '' })} />
      <span className="auth-badge">SECURE AUTHENTICATION</span>
      <h1 className="auth-title">用户登录</h1>
      <p className="auth-desc">欢迎回来，请输入您的账号和密码登录系统。</p>

      <form className="auth-card" onSubmit={handleSubmit}>
        <div className="auth-field">
          <label className="auth-field-label">账号 (ACCOUNT)</label>
          <div className="auth-field-input-wrap">
            <User size={18} className="field-icon" />
            <input
              type="text"
              placeholder="请输入您的账号"
              value={form.account}
              onChange={e => onChange('account', e.target.value)}
            />
          </div>
          {errors.account && <div className="auth-field-error">{errors.account}</div>}
        </div>

        <div className="auth-field">
          <label className="auth-field-label">密码 (PASSWORD)</label>
          <div className="auth-field-input-wrap">
            <Lock size={18} className="field-icon" />
            <input
              type="password"
              placeholder="请输入您的密码"
              value={form.password}
              onChange={e => onChange('password', e.target.value)}
            />
          </div>
          {errors.password && <div className="auth-field-error">{errors.password}</div>}
        </div>

        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? '登录中...' : '登录'} <ArrowRight size={18} />
        </button>

        <div className="auth-links">
          <Link to="/register">注册账号</Link>
          <Link to="/forgot-password">忘记密码</Link>
        </div>
      </form>
    </div>
  );
}

export default Login;
